<template lang="pug">
    .parallaxFigures
        parallax
            .f.f1(data-parallax="3")
                img.line(src="@/assets/img/figures/line_2.png")
            .f.f2(data-parallax="6")
                img(src="@/assets/img/figures/red_romb.png")
            .f.f3(data-parallax="2")
                img(src="@/assets/img/figures/blue_romb.png")
            .f.f4(data-parallax="4")
                img(src="@/assets/img/figures/grey_romb.png")
            .f.f5(data-parallax="5")
                img(src="@/assets/img/figures/blue_circle.png")
            .f.f6(data-parallax="1")
                img.line(src="@/assets/img/figures/line_4.png")
            .f.f7(data-parallax="3")
                img(src="@/assets/img/figures/red_romb_2.png")
            .f.f8(data-parallax="6")
                img(src="@/assets/img/figures/blue_circle.png")
            .f.f9(data-parallax="4")
                img(src="@/assets/img/figures/blue_romb.png")

            .f.f10(data-parallax="2")
                img(src="@/assets/img/figures/red_romb.png")
            .f.f11(data-parallax="3")
                img(src="@/assets/img/figures/grey_romb_2.png")
            .f.f12(data-parallax="6")
                img(src="@/assets/img/figures/red_circle.png")
            .f.f13(data-parallax="1")
                img(src="@/assets/img/figures/blue_romb.png")
            .f.f14(data-parallax="5")
                img(src="@/assets/img/figures/red_circle.png")
            .f.f15(data-parallax="2")
                img.line(src="@/assets/img/figures/line_4.png")
            .f.f16(data-parallax="4")
                img.line(src="@/assets/img/figures/line_3.png")
            .f.f17(data-parallax="1")
                img(src="@/assets/img/figures/blue_circle.png")


</template>

<script>
    import Parallax from "./Parallax";
    export default {
        name: "ParallaxFigures_event",
        components: {Parallax},
    }
</script>

<style scoped lang="scss">
.parallaxFigures{
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
    img{
        display: block;
        width: 100%;
       animation: move 12s infinite;
        &.line{
            animation-name: move_line;
        }
    }
    .f{
        position: absolute;
    }



    .f1{
        z-index: 1;
        right: -6.3rem;
        top: 25vh;
        width: 12rem;
        img{animation-delay: -4s;}
    }
    .f2{
        right: -11.3rem;
        top: 11.7vh;
        width: 14.2rem;
        img{animation-delay: -6s;}
    }

    .f3{
        right: -11rem;
        top: 97.4vh;
        width: 14rem;
        img{animation-delay: -9s;}
    }
    .f4{
        right: -4.5rem;
        top: 124.3vh;
        width: 10.6rem;
        img{animation-delay: -11s;}
    }
    .f5{
        right: 1.5rem;
        top: 155vh;
        width: 2.2rem;
        img{animation-delay: -7s;}
    }
    .f6{
        right: -1.5rem;
        top: 160vh;
        width: 8.4rem;
        img{animation-delay: -4s;}
    }
    .f7{
        right: -11.2rem;
        top: 205vh;
        width: 19.5rem;
        img{animation-delay: -0s;}
    }
    .f8{
        right: -4.4rem;
        top: 231.7vh;
        width: 6.6rem;
        img{animation-delay: -5s;}
    }
    .f9{
        right: -6.1rem;
        top: 283.7vh;
        width: 14rem;
        img{animation-delay: -2s;}
    }

    .f10{
        left: -10.6rem;
        top: 35.5vh;
        width: 14.2rem;
        img{animation-delay: -8s;}
    }
    .f11{
        left: -4.6rem;
        top: 97.4vh;
        width: 8.6rem;
        img{animation-delay: -7s;}
    }
    .f12{
        left: 4.4rem;
        top: 107.4vh;
        width: 3.6rem;
        img{animation-delay: -5s;}
    }
    .f13{
        left: -8.3rem;
        top: 185.7vh;
        width: 14rem;
        img{animation-delay: -11s;}
    }
    .f14{
        left: -5.3rem;
        top: 225vh;
        width: 9rem;
        img{animation-delay: -4s;}
    }
    .f15{
        left: -4rem;
        top: 183vh;
        width: 8.5rem;
        img{animation-delay: -9s;}
    }
    .f16{
        left: -7rem;
        top: 255vh;
        width: 11.5rem;
        img{animation-delay: -3s;}
    }
    .f17{
        left: 1.3rem;
        top: 280.8vh;
        width: 3.2rem;
        img{animation-delay: -6s;}
    }


    @keyframes move_line {
        0% {
            transform: translate3d(0, 0, 0px) rotate(0);
        }
        33% {
            transform: translate3d(-10px, -10px, 25px) rotate(-45deg);
        }
        66% {
            transform: translate3d(10px, 10px, 50px) rotate(45deg);
        }
        100% {
            transform: translate3d(0, 0, 0px) rotate(0);
        }
    }
    @keyframes move {
        0% {
            transform: translate3d(0, 0, 0px);
        }
        33% {
            transform: translate3d(-10px, -10px, 25px);
        }
        66% {
            transform: translate3d(10px, 10px, 50px);
        }
        100% {
            transform: translate3d(0, 0, 0px);
        }
    }
}
</style>